// RealmsService.js
import PortalConfiguration from "../configuration/config";

class RealmsService {
    static async createRealm(ApiCaller, sessionID, realmData) {
        console.log('Creating realm with data:', realmData); // Log the realm data for debugging
        console.log('Session ID:', sessionID); // Log the session ID for debugging
        console.log('API Caller:', ApiCaller); // Log the API Caller for debugging`
        try {
            const result = await ApiCaller.callApi({
                authorization: sessionID,
                service: '/new',
                method: 'PUT',
                body: realmData,
                headers: {
                    applicationID: PortalConfiguration.defaultApplicationID
                }
            });
            return result;
        } catch (error) {
            console.error('Error creating realm:', error);
            throw new Error(error.response?.data || { error: 'Failed to create realm' });
        }
    }

    static async deleteRealm(ApiCaller, sessionID, PK_RealmId, SK_Type) {
        try {
          const result = await ApiCaller.callApi({
            authorization: sessionID,
            service: '/',
            method: 'DELETE',
            params: {
              PK_RealmId,
              SK_Type
            },
            headers: {
              applicationID: PortalConfiguration.defaultApplicationID
            }
          });
          return result;
        } catch (error) {
          console.error('Error deleting realm:', error);
          throw new Error(error.response?.data || 'Failed to delete realm');
        }
      }

    static async updateRealm(ApiCaller, sessionID, originalSK, updatedRealmData) {
        try {
            console.log('Starting the Updating realm with data:', updatedRealmData); // Log the updated realm data for debugging
            const { PK_RealmId, SK_Type } = updatedRealmData;
    
            // If the SK_Type hasn't changed, just do a normal update
            if (originalSK === SK_Type) {
                console.log('Updating realm with data:', updatedRealmData); // Log the updated realm data for debugging
                return await ApiCaller.callApi({
                    authorization: sessionID,
                    service: '/update',
                    method: 'PUT',
                    body: updatedRealmData,
                    headers: {
                        applicationID: PortalConfiguration.defaultApplicationID
                    }
                });
            }
            console.log('SK_Type has changed. Deleting original realm and creating a new one.');
            await this.deleteRealm(ApiCaller, sessionID, PK_RealmId, originalSK); // Delete the original record if SK_Type has changed
            return await this.createRealm(ApiCaller, sessionID, updatedRealmData); // Create a new record with the updated SK_Type
    
        } catch (error) {
            console.error('Error updating realm:', error);
            throw new Error(error.response?.data || { error: 'Failed to update realm' });
        }
    }

    static async checkRealmAvailable(ApiCaller, sessionID, realmId) {
        try {
            const result = await ApiCaller.callApi({
                authorization: sessionID,
                service: '/available',
                method: 'GET',
                params: { 'PK_RealmId': realmId }, 
                headers: {
                    applicationID: PortalConfiguration.defaultApplicationID
                }
            });
            return result.available;
        } catch (error) {
            console.error('Error checking realm availability:', error);
            throw new Error(error.response?.data || { error: 'Failed to check realm availability' });
        }
    }
    
    static async getRealm(ApiCaller, sessionID, realmId) {
        try {
          const result = await ApiCaller.callApi({
            authorization: sessionID,
            service: '/realms',
            method: 'GET',
            params: { 'PK_RealmId': realmId }, 
            headers: {
              applicationID: PortalConfiguration.defaultApplicationID
            }
          });
          return result.records[0];
        } catch (error) {
          console.error('Error fetching realm:', error);
          throw new Error(error.response?.data || { error: 'Failed to fetch realm' });
        }
    }
      
}

export default RealmsService;
